<template>
  <b-form-group
    id="fieldset-1"
    :description="description"
    :label="label" label-cols="3" 
    label-for="inp" label-size="sm"
    :invalid-feedback="invalidFeedback"
    :valid-feedback="validFeedback"
    :state="state"
  >
    <date-picker :name="name" id= "inp" v-model="DOB"
        @input="emitInput" :valueType="valueType" :type="type"
        :format="format" lang="en" size="small">
    </date-picker>
  </b-form-group>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: { DatePicker },
  name: "DateInput",
  props: {
    "placeholder":{},
    "label":{},
    "name":{},
    "value":{},
    "description":{},
    "invalidFeedback":{},
    "validFeedback":{},
    "state":{},
    "required":{type:Boolean},
    valueType: {
      type: String,
      default: 'date', // date, format, timestamp, or token like 'YYYY-MM-DD'
    },
    type: {
      type: String, // ['date', 'datetime', 'time', 'year', 'month', 'week']
      default: 'date',
    },
    format: {
      type: [String, Object],
      default() {
        const map = {
          date: 'YYYY-MM-DD',
          datetime: 'YYYY-MM-DD HH:mm:ss',
          year: 'YYYY',
          month: 'YYYY-MM',
          time: 'HH:mm:ss',
          week: 'w',
        };
        return map[this.type] || map.date;
      },
    },
  },
  data() {
    return {
      DOB: null
    };
  },
  methods:{
      emitInput(evt){
          this.$emit('input',this.DOB);
      }
  }
};
</script>